import styled from 'styled-components';
import { systemColors } from 'utils/defaultValues';

export const Container = styled.div`
  font-size: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  color: ${systemColors.GREEN};
`;
